import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mentor-topic.reducer';

export const MentorTopicDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mentorTopicEntity = useAppSelector(state => state.mentorTopic.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mentorTopicDetailsHeading">
          <Translate contentKey="fivePlusApp.mentorTopic.detail.title">MentorTopic</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{mentorTopicEntity.id}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.mentorTopic.user">User</Translate>
          </dt>
          <dd>{mentorTopicEntity.user ? mentorTopicEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.mentorTopic.topic">Topic</Translate>
          </dt>
          <dd>{mentorTopicEntity.topic ? mentorTopicEntity.topic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/mentor-topic" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mentor-topic/${mentorTopicEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MentorTopicDetail;
